export default __webpack_public_path__ + "static/media/slide9.a31c1270.jpg";